export default __webpack_public_path__ + "static/media/720px-440px-square-PMR-Dev-no-border.jpg.be3f8aea.webp";